












































































































































import { Component, Vue } from "vue-property-decorator";
import InviteCard from "@/components/InviteCard.vue";
import DialogInviteCode from "@/components/DialogInviteCode.vue";
import { INVITE_LIST_URL, WALLET_SETTINGS_URL } from '../assets/js/urls';
import utils from '../assets/js/utils';

const axios = require('../axios/index.js').default;

@Component({
  components: {
    InviteCard,
    DialogInviteCode,
  },
})
export default class Invite extends Vue {
  copySuccess: boolean = false;
  inviteCodeDialogShow: boolean = false;

  inviteList: any[] = [];

  // computed 属性
  get inviteCode(): number {
    return this.$store.state.inviteCode || "";
  }

  // computed 属性
  get balance(): number {
    return this.$store.state.balance || 0;
  }

  // computed 属性
  get currency(): number {
    return this.$store.state.currency || "";
  }

  // computed 属性
  get loginStatus(): boolean {
    if(this.$store.state.isLogin) {
      this.getInviteList();
    }

    return this.$store.state.isLogin;
  }

  // computed 属性
  get avatar(): boolean {
    return this.$store.state.avatar;
  }

  // computed 属性
  get username(): boolean {
    return this.$store.state.username;
  }

  mounted() {
    if(this.$as) {
      this.$as.send("loaded_page_Invite");
    }
    
    // console.log('invite.mounted', this.loginStatus);
  }

  // 获取邀请列表
  getInviteList():any {
    let self = this;

    let resData:any = null;

    self.$bus.$emit('show-loading', true);
    axios.post(INVITE_LIST_URL, {})
      .then((res:any) => {
        resData = res.data;

        self.$bus.$emit('show-loading', false);
        if(resData.status.code == 0) {
          self.inviteList = resData.result.list;
        }else {
          self.$toasted.show(resData.status.reason)
        }
      })
      .catch((err:any) => {
        self.$bus.$emit('show-loading', false);
        self.$toasted.show(err)
      })
  }

  // 格式化时间
  formatDate(ts: string) {
    return utils.formatDate(ts);
  }

  showInviteCodeDialog() {
    this.$as.send('click_redeem_code_btn_Invite');
    this.inviteCodeDialogShow = true;
  }

  // 显示/隐藏 对话框
  setInviteCodeDialog(flag: boolean, evt: any) {
    this.inviteCodeDialogShow = flag;
  }

  goWallet() {
    let self = this;
    
    if (self.loginStatus) {
      this.$as.send('click_go_btn_Invite')
      self.$router.push("/");
    } else {
      // console.log('login ...');
      this.$as.send('click_login_btn_Invite')
      self.loginFn();
    }
  }

  // 邀请好友
  inviteFriend() {
    let self = this;
    let sMsg: any = {
        action: 'invite',
        msg: ''
    }

    // console.log("invite friends.", self.$JBH);
    self.$as.send('click_invite_friends_btn_Invite');
    if(self.loginStatus) {
      self.$as.send('send_invite_friends_to_app_Invite');
      self.$JBH.sendMsg(JSON.stringify(sMsg), function (res: any) {
        // console.log("invite res: ", res);
      });
    }else{
      self.$as.send('click_invite_friends_btn_to_login_Invite');
      self.loginFn();
    }
  }

  loginFn() {
    let self = this;
    let loginMsg: any = {
      action: 'login',
      msg: '',
    }

    self.$bus.$emit('show-loading', true);
    self.$JBH.sendMsg(JSON.stringify(loginMsg), (res: any) => {
      // console.log('login res: ', res);
      let info: any = {};

      self.$bus.$emit('show-loading', false);
      if (res) {
        if (typeof res === "string") {
          info = JSON.parse(res);
        } else {
          info = res;
        }
        console.log('info = ', info);

        if (info.ref_token) {
          self.$as.send('login_successful_Invite');
          info.flag = true;
          self.$store.dispatch("setLogin", info);
          self.$bus.$emit('get-config');
          self.getInviteList();
        }else{
          self.$as.send('login_failed_Invite');
          info.flag = false;
          self.$store.dispatch("setLogin", info);
        }
      }
    });
  }

  // copy invite code
  copyCode() {
    let self = this;
    let sMsg: any = {
        action: 'copy',
        msg: self.inviteCode
    }
    
    // console.log("copy invite code:", sMsg);
    self.$as.send('click_copy_code_btn_Invite');
    if(self.loginStatus) {
      self.$as.send('send_copy_code_to_app_Invite');
      self.$JBH.sendMsg(JSON.stringify(sMsg), function (res: any) {
        // console.log("copy res: ", res);
        if(res === 'Success') {
          self.$as.send('copy_code_successful_Invite');
          self.copySuccess = true;
        }else{
          self.$as.send('copy_code_failed_Invite');
        }
      });
    }else{
      self.$as.send('click_copy_code_btn_to_login_Invite');
      self.loginFn();
    }
  }
}
